import { render } from "./SvgSpriteChat.vue?vue&type=template&id=b5068f70"
import script from "./SvgSpriteChat.vue?vue&type=script&lang=js"
export * from "./SvgSpriteChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/parts/SvgSpriteChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5068f70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5068f70', __exports__)) {
    api.reload('b5068f70', __exports__)
  }
  
  module.hot.accept("./SvgSpriteChat.vue?vue&type=template&id=b5068f70", () => {
    api.rerender('b5068f70', render)
  })

}


export default __exports__